export default __webpack_public_path__ + "static/media/actionable-metrics.ada0b4a5.svg";